import { cn } from "@/lib/utils";

export const STATUS_STYLES = {
  Draft: "bg-slate-100 text-slate-700 border-slate-300",
  Open: "bg-blue-50 text-blue-700 border-blue-200",
  "In Progress": "bg-yellow-50 text-yellow-800 border-yellow-300",
  "Hold Point Pending": "bg-orange-50 text-orange-700 border-orange-200",
  "Hold Point Rejected": "bg-red-50 text-red-700 border-red-200",
  "Awaiting Client Review": "bg-orange-50 text-orange-700 border-orange-200",
  "Under Review": "bg-orange-50 text-orange-700 border-orange-200",
  "Approved / Released": "bg-green-50 text-green-700 border-green-200",
  Approved: "bg-green-50 text-green-700 border-green-200",
  Published: "bg-green-50 text-green-700 border-green-200",
  Rejected: "bg-red-50 text-red-700 border-red-200",
  "More Information Required": "bg-purple-50 text-purple-700 border-purple-200",
  Closed: "bg-emerald-100 text-emerald-800 border-emerald-300",
  "Ready for Review": "bg-sky-50 text-sky-700 border-sky-200",
  "QA Incomplete": "bg-amber-50 text-amber-700 border-amber-200",
  "Ready to Submit": "bg-blue-50 text-blue-700 border-blue-200",
  Submitted: "bg-orange-50 text-orange-700 border-orange-200",
  "Not Started": "bg-slate-100 text-slate-600 border-slate-300",
  Complete: "bg-green-50 text-green-700 border-green-200",
  // NCR
  "Action Required": "bg-yellow-50 text-yellow-800 border-yellow-300",
  // ITP
  Approved_ITP: "bg-green-50 text-green-700 border-green-200",
  Active: "bg-green-50 text-green-700 border-green-200",
  Imported: "bg-teal-50 text-teal-700 border-teal-200",
  Superseded: "bg-slate-200 text-slate-700 border-slate-300",
  Archived: "bg-slate-200 text-slate-600 border-slate-300",
};

export default function StatusBadge({ status, className }) {
  const style = STATUS_STYLES[status] || "bg-slate-100 text-slate-700 border-slate-300";
  return (
    <span
      data-testid={`status-badge-${(status || "").toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
      className={cn(
        "inline-flex items-center gap-1.5 rounded-md border px-2 py-0.5 text-xs font-semibold whitespace-nowrap",
        style,
        className
      )}
    >
      <span className="size-1.5 rounded-full bg-current opacity-60" />
      {status || "—"}
    </span>
  );
}
